import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { firebaseConnect } from 'react-redux-firebase';
import { AppView, CreatorDocumentS } from 'medua-components';

/* eslint-disable */
@firebaseConnect()
@translate(['actions'])
export default class CoursesCourseDescription extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: props.course && props.course.description ? props.course.description : '<h1>Wählen Sie eine Überschrift</h1><p>Aktiviere unten den Bearbeitungsmodus und schreibe Notizen</p>',
      readOnly: true,
      modalIsOpen: false
    };

    this.handleOnChange = this.handleOnChange.bind(this);
    this.handleOnBlur = this.handleOnBlur.bind(this);
    this.handleLock = this.handleLock.bind(this);
  }

  handleOnChange(value) {
    this.setState({ value });
  }

  handleOnBlur(value) {
    this.setState({ value });
  }

  handleLock() {
    if (this.state.readOnly) {
      this.setState({ readOnly: false })
    } else {
      this.setState({ readOnly: true })
      if (this.state.value.localeCompare(this.props.course.description) != 0) {
        this.props.firebase.update(
          `courses/${this.props.course.key}`, {
            description: this.state.value
        })
        // toast.success("Saved!")
      }
    }
  }

  render() {
    let button;
    if (this.state.readOnly) {
      button = { text: this.props.t('actions:text.edit'), action: this.handleLock }
    } else {
      if (!this.props.course.description || this.state.value.localeCompare(this.props.course.description) != 0) {
        button = { type: 'success', text: this.props.t('actions:text.save'), action: this.handleLock }
      } else {
        button = { text: this.props.t('actions:text.close'), action: this.handleLock }
      }
    }
    return (
      <AppView
        tabcontent
        buttons={[
          button
        ]}
      >
        <CreatorDocumentS
          readOnly={this.state.readOnly}
          value={this.state.value}
          onChange={this.handleOnChange}
          onBlur={this.handleOnBlur}
        />
      </AppView>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/courses/course/description/index.jsx